import React from 'react';
import classNames from 'classnames';
import styles from './typeahead-overlay.scss';

interface TypeaheadOverlayProps {
  isTypeaheadOpen: boolean;
  onClickAway: () => void;
  isWhiteTypeaheadActive?: boolean;
}

export const TypeaheadOverlay = ({
  isTypeaheadOpen,
  onClickAway,
  isWhiteTypeaheadActive = false,
}: TypeaheadOverlayProps) => {
  const transparentOverlayClasses = classNames(styles.bpTransparentOverlay, {
    [styles.bpTransparentOverlay__hidden]: !isTypeaheadOpen,
  });

  const bpOverlayClasses = classNames(styles.bpOverlay, {
    [styles.bpOverlay__hidden]: !isTypeaheadOpen,
    [styles.bpOverlay__white]: isWhiteTypeaheadActive,
  });

  return (
    <>
      <div
        className={transparentOverlayClasses}
        data-testid="search-transparent-overlay"
        onClick={onClickAway}
      />
      <div className={bpOverlayClasses} data-testid="search-bp-overlay" />
    </>
  );
};
